// extracted by mini-css-extract-plugin
module.exports = {"opened":"ENM06HSa","wrapper":"_1GNJUO9E","normal":"SWsGeNAG"};